import React, { Suspense } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAxios } from 'hooks';
import { endPoints } from 'api/endpoints';
import { useRecoilState } from 'recoil';
import { useParams } from 'react-router-dom';
import { catalogs } from 'store';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { orderId, sspSubmitOrder, toggleSspModels } from 'pages/provisioning/aws/external-url-onboarding/store';
import { resetOrder, resetToggleSspModal, formOrderObjFromOrderDetails } from './utils/index';

const ProvisioningHeader = React.lazy(() => import('pages/provisioning/aws/external-url-onboarding/ProvisioningHeader'));
const ApplicationDetails = React.lazy(() => import('pages/provisioning/aws/external-url-onboarding/ApplicationDetails'));
const SspForm = React.lazy(() => import('pages/provisioning/aws/external-url-onboarding/SspForm'));
const OrderSuccessDialog = React.lazy(() => import('pages/provisioning/aws/external-url-onboarding/OrderSuccessDialog'));
const ShowCostDetails = React.lazy(() => import('pages/provisioning/aws/external-url-onboarding/ShowCostDetails'));

const AWSExternalUrlOnboardProvisioningPage = () => {
    const [isLoading, setLoading] = React.useState(true);
    const [cmpCatalogs] = useRecoilState(catalogs);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [, resetOrderId] = useRecoilState(orderId);
    const [, resetToggleSspModels] = useRecoilState(toggleSspModels);
    const { catalogCode, cartItemId, operation, catalogServiceId } = useParams();
    const axios = useAxios();

    async function getCosts() {
        const { data } = await axios.get(`${endPoints.catalog.get}/${catalogCode}/costs`);
        return data;
    }

    // Helper function to fetch landing zone details
    // const fetchLandingZoneDetails = async (orderData) => {
    //     if (orderData?.appProfile && orderData?.sector && orderData?.department && orderData?.appRegion && orderData?.environment) {
    //         const payload = {
    //             applicationServiceName: orderData.appProfile,
    //             sector: orderData.sector,
    //             environment: orderData.environment,
    //             department: orderData.department,
    //             applicationRegion: orderData.appRegion,
    //         };
    //         try {
    //             const landingZoneResponse = await axios.post(endPoints.aws.Ec2.awsLandingZone, payload);
    //             return landingZoneResponse?.data;
    //         } catch (error) {
    //             console.error('Landing zone API error:', error);
    //             return null;
    //         }
    //     }
    //     return null;
    // };

    async function checkCatalog() {
        const { data } = await axios.get(`${endPoints.catalog.get}/${catalogCode}`);
        const costs = await getCosts();
        if (cartItemId && operation && catalogServiceId) {
            const { data: orderDetails } = await axios.get(`${endPoints.order.orderDetails}/${cartItemId}`);
            const orderObj = formOrderObjFromOrderDetails(catalogServiceId, orderDetails);
            // const landingZoneDetails = await fetchLandingZoneDetails(orderObj);
            setOrder((previous) => ({
                ...previous,
                ...orderObj,
                // landingZoneDetails,
                emptyCost: costs,
            }));
        } else {
            setOrder((previous) => ({
                ...previous,
                catalogCode,
                catalogType: data?.displayName,
                cloudProvider: data?.cloudProvider,
                cloudService: data?.cloudService,
                validationStatus: 'clearValidation',
                isTouched: false,
                emptyCost: costs,
            }));
        }
        setLoading(false);
    }

    const reset = () => {
        setOrder({ ...order, ...resetOrder });
        resetOrderId('');
        resetToggleSspModels(resetToggleSspModal);
    };

    React.useEffect(() => {
        if (cmpCatalogs?.length && catalogCode) {
            setLoading(true);
            reset();
            checkCatalog();
        }
    }, [cmpCatalogs, catalogCode]);

    React.useEffect(() => {
        return () => reset();
    }, []);

    return (
        <>
            <Suspense
                fallback={
                    <Box sx={ProvisioningStyles.provisioning_wrapper}>
                        <CircularProgress color="inherit" size={16} sx={ProvisioningStyles.circularProgressColor} />
                        <Typography variant="body2" sx={ProvisioningStyles.circularProgressColor}>
                            Loading
                        </Typography>
                    </Box>
                }
            >
                {isLoading && (
                    <Box sx={ProvisioningStyles.provisioning_wrapper}>
                        <CircularProgress color="inherit" size={16} sx={ProvisioningStyles.circularProgressColor} />
                        <Typography variant="body2" sx={ProvisioningStyles.circularProgressColor}>
                            Loading
                        </Typography>
                    </Box>
                )}
                {!isLoading && (
                    <Box sx={ProvisioningStyles.provisioningBox}>
                        <ProvisioningHeader />
                        <Box sx={ProvisioningStyles.sspform_wrapper} className="contentContainer">
                            <SspForm />
                        </Box>
                        <br />
                        <OrderSuccessDialog />
                        <ApplicationDetails />
                        <ShowCostDetails />
                    </Box>
                )}
            </Suspense>
        </>
    );
};

export default React.memo(AWSExternalUrlOnboardProvisioningPage);
